import request from '../../utils/request';
import type { AbnormalSummary, HospitalDetail } from '@/types';
import { useAppStore } from '@/store/appStore';

export interface AbnormalSummaryParams {
  platform?: string;
  batch: string;
}

/** Fetch abnormal sales summary for a platform + batch. */
export function fetchAbnormalSummary(params: AbnormalSummaryParams): Promise<AbnormalSummary> {
  return request.get('/api/analysis/abnormal/summary', { params }).then((res) => res.data);
}

/** Fetch hospital detail. */
export function fetchHospitalDetail(hospitalCode: string, batch: string): Promise<HospitalDetail> {
  return request.get(`/api/analysis/abnormal/hospitals/${encodeURIComponent(hospitalCode)}`, { params: { batch } })
      .then((res) => {
        const data = res.data as HospitalDetail;
        const exchangeRate = useAppStore.getState().selectExchange?.exchangeRate ?? 1;
        return {
          ...data,
          productMetrics: data.productMetrics.map((metric) => ({
            ...metric,
            valValue: metric.valValue * exchangeRate,
          })),
        };
      });
}

export interface SubmitFeedbackPayload {
  hospitalCode: string;
  yearMonth: string;
  reviewResult: string;
  feedbackTags: string[];
}

/** Submit IRAI feedback for a hospital. */
export function submitFeedback(payload: SubmitFeedbackPayload): Promise<void> {
  return request.post('/api/analysis/abnormal/feedback', payload).then((res) => res.data);
}
